/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRouteSquare2 = createReactComponent("outline", "route-square-2", "IconRouteSquare2", [["path", { "d": "M14 5a2 2 0 0 0 -2 2v10a2 2 0 0 1 -2 2", "key": "svg-0" }], ["path", { "d": "M3 17h4v4h-4z", "key": "svg-1" }], ["path", { "d": "M17 3h4v4h-4z", "key": "svg-2" }]]);

export { IconRouteSquare2 as default };
//# sourceMappingURL=IconRouteSquare2.mjs.map
